import { Select as Mui4Select, SelectProps as Mui4SelectProps } from '@material-ui/core'
import { default as Mui5Select, SelectProps as Mui5SelectProps } from '@mui/material/Select'
import { FieldTitle, Icon } from 'opensolar-ui'
import React, { forwardRef, useState } from 'react'
import { useComponentVersion } from '../hooks'
import { StyledHelperTextSelect3 } from '../other/common/StyledHelperText'
import {
  StyledHelpIconWrapper,
  StyledLabelInnerWrapper,
  StyledLabelWrapper,
  StyledMainWrapper,
  StyledOptionLabel,
} from '../other/select/SelectWrapper'

const IconComponent = (props) => {
  return <Icon icon={'keyboard_arrow_down'} {...props} />
}

export enum OsSelectVersion {
  V1 = 1, // MUI4
  V2 = 2, // MUI5 + Stratis UI
}
export type SelectProps = Mui4SelectProps & {
  helperText?: string
  optionLabel?: string
  helpIcon?: React.ReactNode
  sx?: Mui5SelectProps['sx']
}

export const Select = forwardRef<unknown, SelectProps>((props, ref) => {
  const version = useComponentVersion('select')
  const [isActiveOrFocus, setIsActiveOrFocus] = useState(false)
  switch (version) {
    case OsSelectVersion.V2:
      const {
        onInvalid,
        onChange,
        MenuProps,
        label,
        helperText,
        optionLabel,
        helpIcon,
        fullWidth,
        error,
        required,
        ...rest
      } = props
      const onInvalid5: Mui5SelectProps['onInvalid'] = onInvalid as Mui5SelectProps['onInvalid']
      const onChange5: Mui5SelectProps['onChange'] = onChange as Mui5SelectProps['onChange']
      const MenuProps5: Mui5SelectProps['MenuProps'] = MenuProps as Mui5SelectProps['MenuProps']
      return (
        <StyledMainWrapper style={{ width: fullWidth ? '100%' : 'auto' }}>
          {(label || optionLabel || helpIcon) && (
            <StyledLabelWrapper>
              <StyledLabelInnerWrapper>
                {label && (
                  <FieldTitle required={required} label={label} error={error} isActiveOrFocus={isActiveOrFocus} />
                )}
                {helpIcon && <StyledHelpIconWrapper isActiveOrFocus={isActiveOrFocus} error={error}>{helpIcon}</StyledHelpIconWrapper>}
              </StyledLabelInnerWrapper>
              {optionLabel && <StyledOptionLabel variant="body2" error={error} isActiveOrFocus={isActiveOrFocus}>{optionLabel}</StyledOptionLabel>}
            </StyledLabelWrapper>
          )}
          <Mui5Select
            ref={ref}
            IconComponent={IconComponent}
            onInvalid={onInvalid5}
            onChange={onChange5}
            MenuProps={MenuProps5}
            fullWidth={fullWidth}
            error={error}
            onFocus={(e) => {
              if (props.onFocus) {
                props.onFocus(e)
              }
              setIsActiveOrFocus(true)
            }}
            onBlur={(e) => {
              if (props.onBlur) {
                props.onBlur(e)
              }
              setIsActiveOrFocus(false)
            }}
            {...rest}
          />
          {helperText && <StyledHelperTextSelect3>{helperText}</StyledHelperTextSelect3>}
        </StyledMainWrapper>
      )

    default:
      return <Mui4Select ref={ref} {...props} />
  }
})
